import Link from "next/link";
import React, { Fragment } from "react";
import styles from "./breadcrumbs.module.scss";

const BreadCrumbs = ({ data }) => {
  return (
    <Fragment>
      {data && data?.length > 0 ? (
        <div className={styles.breadcrumb_wrapper}>
          {data?.map((item, i) => {
            if (item?.isLink) {
              return (
                <Link href={item?.url || "#"} key={i}>
                  {item?.title}
                </Link>
              );
            } else {
              return (
                <span
                  key={i}
                  className={`${item?.isActive ? styles.active : ""}`}
                >
                  {item?.title}
                </span>
              );
            }
          })}
        </div>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default BreadCrumbs;
